/**
 * App
 *
 * Copyright (c) 2020 Aperia Company
 * Released under the MIT license
 */
"use strict";
// Libraries
import "@plugins/slick.min.js";

// App
import Core from "@modules/core";
import Sticky from "@modules/sticky";
import Menu from "@modules/menu";
import Custom from "@modules/custom";
import { Slider, SliderThumbnail } from "@modules/slider";

// Bootstraps
import Modal from "bootstrap/js/dist/modal";
import Tab from "bootstrap/js/dist/tab";
import Alert from "bootstrap/js/dist/alert";
import Dropdown from "bootstrap/js/dist/dropdown";
import Toast from "bootstrap/js/dist/toast";
import Collapse from "bootstrap/js/dist/collapse";

/**
 * Export
 */
export {
  Core,
  Sticky,
  Menu,
  Slider,
  SliderThumbnail,
  Custom,
  Modal,
  Tab,
  Toast,
  Collapse,
  Dropdown,
  Alert
};
